// RegisterModal.jsx
import React, { useState } from "react";
import ModalNew from "../../../Components/Modal/modal-new";
import InputWrapper from "../../../Components/Input/Input-Wrapper";
import CustomSelector from "../../../Components/Input/Custom-Selector";
import CustomInput from "../../../Components/Input/Custom-Input";
import CustomizeButton from "../../../Components/Button/Customize-Button";
import { toast } from "react-toastify";
import { registerUser } from "../../../Api/apiService";
import { validateEmail, validateEmpId, validateName, validatePassword } from "../../../Utils/commonFunction";


const RegisterationModal = ({ visible, onClose, employeeList }) => {
  // Form states
  const [selectedRole, setSelectedRole] = useState(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [empId, setEmpId] = useState("");

  // Submit handler
  const handleRegister = async () => {


    const nameError = validateName(name);
    const emailError = validateEmail(email);
    const passwordError = validatePassword(password);
    const empIdError = validateEmpId(empId);

    if (!selectedRole) {
      toast.warning("Please select a role.", { autoClose: 2000 });
      return;
    }

    // Show errors if any
    if (nameError) {
      toast.warning(nameError, { autoClose: 2000 });
      return;
    }
    if (emailError) {
      toast.warning(emailError, { autoClose: 2000 });
      return;
    }
    if (passwordError) {
      toast.warning(passwordError, { autoClose: 2000 });
      return;
    }
    if (empIdError) {
      toast.warning(empIdError, { autoClose: 2000 });
      return;
    }

    try {
      console.log("Selected Role:", selectedRole, "Name:", name, "Email:", email, "Password:", password, "Employee ID:", empId);
      const encodedPassword = btoa(password);

      const response = await registerUser(name, email, encodedPassword, empId, selectedRole);

      if (response?.status === 200 || response?.status === 201) {
        toast.success(response?.data?.message || "User registration successful.", {
          autoClose: 2000,
        });
        setTimeout(() => {
          window.location.href = "/dashboardHr";
        }, 2000);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };

  return (
    <ModalNew title="Register New Employee" visible={visible} onClose={onClose}>
      <div className="selector-container">
        <InputWrapper label="Role" required>
          <CustomSelector
            options={employeeList}
            value={selectedRole}
            onChange={(value) => setSelectedRole(value)}
            className="role-selector"
            placeholder="Select a Role"
          />
        </InputWrapper>

        <InputWrapper label="Name" required>
          <CustomInput
            className="role-selector"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </InputWrapper>

        <InputWrapper label="Email" required>
          <CustomInput
            className="role-selector"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </InputWrapper>

        <InputWrapper label="Password" required>
          <CustomInput
            className="role-selector"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </InputWrapper>

        <InputWrapper label="Employee ID" required>
          <CustomInput
            className="role-selector"
            value={empId}
            onChange={(e) => setEmpId(e.target.value)}
          />
        </InputWrapper>

        <div
          style={{
            width: "100%",
            display: "flex",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <CustomizeButton
            onClick={handleRegister}
            className="navigate-btn"
            variant="primary"
          >
            Register Employee
          </CustomizeButton>
          <CustomizeButton
            onClick={onClose}
            className="navigate-btn"
            variant="outlined"
          >
            Cancel
          </CustomizeButton>
        </div>
      </div>
    </ModalNew>
  );
};

export default RegisterationModal;
